<template>
  <div>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title><b>BOOK•ME</b></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon large>security</v-icon>
      </v-toolbar>
      <v-form @submit.prevent="login" method="post">
        <v-card-text>
          <v-text-field prepend-icon="person"
                        name="username"
                        label="Username"
                        type="text"
                        v-model="username"></v-text-field>
          <v-text-field prepend-icon="lock"
                        name="password"
                        label="Password"
                        type="password"
                        v-model="password"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" type="submit" :loading="formLoading">Login</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <!-- Snackbar section-->
    <v-snackbar
      :timeout="snackbarTimeout"
      :color="snackbarColor"
      v-model="snackbar"
      top
    >
      {{ snackbarText }}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Login",

  data() {
    return {
      username: "",
      password: "",
      snackbar: false,
      snackbarColor: '',
      snackbarMode: '',
      snackbarTimeout: 6000,
      snackbarText: '',
      formLoading: false
    }
  },

  methods: {
    login: function () {
      this.formLoading = true;
      let username = this.username;
      let password = this.password;
      this.$store.dispatch('login', {username, password})
        .then(() => {
          this.formLoading = false;
          this.$router.push('/')
        })
        .catch(err => {
          this.formLoading = false;
          this.showSnackbar('error', 'Authentication failed with status ' + err.status + ': '
            + err.data.error_description);
          console.log(err.data.error_description)
        });
    },
    showSnackbar(snackbarColor, snackbarText) {
      this.snackbarColor = snackbarColor;
      this.snackbarText = snackbarText;
      this.snackbar = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue